/*

{
  identifier: {
    pk: ORG#{orgId}#BRANDING
    sk: STATE#{state}#ORG#{orgId}#BRANDING
  }
  orgLogo: s3BucketPath
  text: richText
  orgId
  ...
}

*/

const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');
const Joi = require('joi');
const { STATES } = require('@bcm/constants');

const schema = {
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  orgId: Joi.string().required(),
  logoURL: Joi.string().optional(),
  logoThumbnailURL: Joi.string().optional(),
  logoMetadata: Joi.object().optional(),
  logoFileType: Joi.string().optional(),
  logoId: Joi.string().optional(),
  text: Joi.string().optional(),
};

class Branding extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.branding.buildPk(obj.orgId),
      identifiers.branding.buildSk(obj.state, obj.orgId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Branding = Branding;
exports.brandingSchema = schema;
